import styled from 'styled-components';

export const SectionContainer = styled.div`
	width: 80%;
	background-color: inherit;
	margin: 4em auto;
	padding: 2rem 0;
	display: flex;
	flex-direction: column;

`;
